<template>
  <div class="pa-0 secondary--text text--darken-3">
    <!-- Header Area -->
    <div class="bg-grey-light pa-8 border-bottom">
      <div class="d-flex align-center mb-2">
        <v-avatar color="primary" size="40" class="mr-4 shadow-sm">
          <v-icon color="white" small>fas fa-balance-scale</v-icon>
        </v-avatar>
        <div>
          <div class="text-h5 font-weight-black primary--text lh-1">{{ item.id > -1 ? 'Editar Unidad' : 'Nueva Unidad' }}</div>
          <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Definición de magnitudes de medida</div>
        </div>
      </div>
    </div>

    <div class="pa-8">
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(save)">
          
          <!-- Section: Details -->
          <div class="caption primary--text font-weight-black text-uppercase tracking-widest mb-6 d-flex align-center">
            <v-icon x-small color="primary" class="mr-2">fas fa-info-circle</v-icon> Nombre de la Unidad
          </div>

          <v-row dense class="mb-4">
            <v-col cols="12">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="item.name"
                  label="Unidad de Medida"
                  placeholder="Ej: Kilogramos, Metros, Unidades..."
                  outlined
                  dense
                  class="modern-input bg-white"
                  :error-messages="errors"
                  :loading="loading"
                  prepend-inner-icon="fas fa-tag"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-alert
            outlined
            color="primary"
            class="modern-alert rounded-lg mt-4 pa-4"
            icon="fas fa-compass"
          >
            <div class="body-2 font-weight-bold mb-1">Estandarización de Medida</div>
            <div class="caption opacity-80">Las unidades de medida aseguran la precisión en el control de stock, compras y consumos de materiales.</div>
          </v-alert>

          <!-- Footer Buttons -->
          <div class="d-flex mt-10 gap-3">
            <v-btn 
              type="submit" 
              color="primary" 
              large 
              depressed 
              :loading="loading"
              class="flex-grow-1 py-6 rounded-lg font-weight-black text-uppercase tracking-widest shadow-md"
            >
              <v-icon small class="mr-2">fas fa-save</v-icon>
              {{ item.id > -1 ? 'Actualizar' : 'Crear Unidad' }}
            </v-btn>
            <v-btn 
              text 
              large 
              color="grey darken-1"
              class="rounded-lg font-weight-bold px-8"
              @click.prevent="$emit('close')"
            >
              Cancelar
            </v-btn>
          </div>
        </v-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { getUnit, createUnit, updateUnit } from '@/api/stocks'
import notifications from '@/utils/notifications'

export default {
  name: 'UnitCreateUpdate',
  props: {
    id: { required: true }
  },
  data() {
    return {
      item: { id: -1, name: '' },
      loading: false,
    }
  },
  methods: {
    async save() {
      this.loading = true
      try {
        if (this.id > -1) {
          await updateUnit(this.id, { name: this.item.name })
          notifications.showSuccess('Unidad actualizada')
        } else {
          await createUnit({ name: this.item.name })
          notifications.showSuccess('Nueva unidad registrada')
        }
        this.$emit('updated')
        this.$emit('close')
      } catch (err) {
        notifications.showError('Error al guardar: ' + err.message)
      } finally {
        this.loading = false
      }
    },
    async get() {
      if (this.id > -1) {
        this.loading = true
        try {
          const res = await getUnit(this.id)
          this.item = res
        } catch (err) {
          notifications.showError('Error al cargar datos')
        } finally {
          this.loading = false
        }
      } else {
        this.item = { id: -1, name: '' }
      }
    }
  },
  watch: {
    id: { handler: 'get', immediate: true }
  }
}
</script>

<style scoped>
.bg-grey-light { background-color: #f8f9fa; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 2px; }
.tracking-wider { letter-spacing: 1px; }
.gap-3 { gap: 12px; }
.opacity-80 { opacity: 0.8; }

.modern-input >>> .v-input__control { min-height: 48px !important; }
.modern-input >>> fieldset { border: 1px solid rgba(0,0,0,0.1) !important; border-radius: 8px !important; }
.modern-input >>> .v-input__prepend-inner { margin-top: 12px !important; margin-right: 12px !important; }

.shadow-md { box-shadow: 0 4px 12px rgba(var(--v-primary-base), 0.2) !important; }
.shadow-sm { box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important; }

.modern-alert { border-width: 1px !important; background-color: rgba(var(--v-primary-base), 0.02) !important; }
</style>